import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import IconInfo from '@scramble/design-system/icons/info-circle-02.svg?react';
import IconClose from '@/assets/icons/icon_close.svg?react';
import s from './index.module.scss';

export const AmlAlert = ({ type = 'info', title, description, actionLabel, onAction, onClose, className }) => {
  const { t } = useTranslation('dashboard');

  return (
    <div className={classnames(s.alert, s[type], className)} role="alert" data-testid="aml-alert">
      <IconInfo className={s.icon} width={24} height={24} aria-hidden="true" />
      <div className={s.body}>
        <div className={s.content}>
          {title && <p className={classnames(s.text, 'f-16 f-500')}>{title}</p>}
          {description && <p className={classnames(s.text, 'f-14 f-400')}>{description}</p>}
        </div>
        {actionLabel && onAction && (
          <button type="button" className={classnames(s.action, 'f-14 f-400')} onClick={onAction}>
            {actionLabel}
          </button>
        )}
      </div>
      {onClose && (
        <button
          type="button"
          className={s.close}
          onClick={onClose}
          aria-label={t('aml_alerts.close')}
        >
          <IconClose width={24} height={24} aria-hidden="true" />
        </button>
      )}
    </div>
  );
};
